"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.error = exports.warn = exports.info = exports.debug = exports.verbose = void 0;
const core_utility_1 = require("@built/core-utility");
_a = (0, core_utility_1.getScopedLogger)('built-auth-utility'), exports.verbose = _a.verbose, exports.debug = _a.debug, exports.info = _a.info, exports.warn = _a.warn, exports.error = _a.error;
